import React from 'react'
import { connect } from 'react-redux'
import { getSystemMessage } from 'data/messages/action'

class LoginMessage extends React.Component { 
  componentDidMount() {
    this.props.getSystemMessage()
  }
  
  render(){
    const { message } = this.props
    return (
      <React.Fragment>
        { message && message.body && message.body.length !== 0 ?
          <div className='Message'>
            <div className='Message-header'>{message.header}</div>
            {  message.body.map((msg,i)=>{
                return (             
                  <div key={`div-${i}`}>             
                    { msg }
                  </div>
                )  
              })
            }
          </div>
          :
          null
        }
      </React.Fragment>
    )
  }
}

function mapStateToProps(state) {
  return {
    message: state.shared_data.messages.system
  }
}

export default connect(mapStateToProps, { getSystemMessage })(LoginMessage)
